<template>
  <v-app>
    <div class="status">
      <div class="status-content">
        <div class="status-img-wrapper">
          <svg-icon :icon="`img-${type}`" class="status-featured" width="860" height="300" />
          <img v-if="type == 'loading'" src="@/assets/images/alarm-clock.gif" class="img-alarm" />
        </div>
        <h1 class="status-heading">{{ $t(title) }}</h1>
        <div class="status-content mb-8">{{ $t(subtitle) }}</div>
        <v-btn v-if="!['maintenance', 'busy'].includes(this.type)" color="primary btn-primary-custom" width="260" @click="onBack()">
          {{ $t('success.back') }}
        </v-btn>
      </div>
    </div>
  </v-app>
</template>

<script>
export default {
  name: 'StatusScreen',
  props: {
    type: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    },
    back: {
      type: Function,
      default: null
    }
  },
  methods: {
    onBack() {
      if (this.type === 'not-found') {
        this.$router.push({ name: 'AuthLogin' });
      }
      this.back && this.back();
      this.$emit('back');
    }
  }
};
</script>

<style lang="scss" scoped>
.status {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f2f3fc;
  text-align: center;
  font-family: Montserrat;
  font-weight: 500;

  &-content {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 20px;
  }

  &-featured {
    width: 100%;
    margin-bottom: 30px;
  }

  &-heading {
    color: #6d6d6d;
    font-family: Montserrat;
    font-weight: bold;
    font-size: 24px;
  }

  &-img-wrapper {
    position: relative;
  }

  .img-alarm {
    position: absolute;
    left: 380px;
  }

  @include query-min-sm() {
    &-featured {
      width: auto;
      height: 340px;
    }
  }
}
</style>
